













import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import Component from 'vue-class-component';
import {Action} from 'vuex-class';
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import {Prop} from "vue-property-decorator";

@Component
export default class ArrearsAlertTab extends AfterFetchComponent {

    @Action('getArrearsAlerts', StoreNamespace.CUSTOMER_SERVICE) getArrearsAlerts: any

    @Prop() memberIdNum!: string

    private innerColumns: GridColumn[] = []
    private columns: GridColumn[] = []

    beforeMount() {
        this.hasFeedback = true
    }

    mounted() {
        this.initColumns();
        this.initInnerColumns();
        this.getArrearsAlerts({
            pathVariable: this.memberIdNum,
            requestorCallback: this,
            requestBody: {
                pageNumber: 0,
                pageSize: 10
            }
        })
    }

    onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
        this.$emit('successResults', data)
    }

    private initColumns(): void {
        this.columns.push({property: 'date', header: 'date'} as GridColumn)
        this.columns.push({property: 'fundName', header: 'fund_name'} as GridColumn)
        this.columns.push({property: 'arrearsSum'} as GridColumn)
        this.columns.push({property: 'interestSum'} as GridColumn)
        this.columns.push({property: 'totalSum'} as GridColumn)
        this.columns.push({property: 'alertText'} as GridColumn)

        this.columns.forEach((column: GridColumn) => column.hideSorting = true)
    }

    private initInnerColumns(): void {
        this.innerColumns.push({property: 'codeId', header: 'codeId'} as GridColumn)
        this.innerColumns.push({
            property: 'employeeLastSalaryMonth',
            header: 'employee_last_salary_month'
        } as GridColumn)
        this.innerColumns.push({
            property: 'employerLastSalaryMonth',
            header: 'employer_last_salary_month'
        } as GridColumn)
        this.innerColumns.push({property: 'employeeLastDepDate', header: 'employee_last_depDate'} as GridColumn)
        this.innerColumns.push({property: 'employerLastDepDate', header: 'employer_last_depDate'} as GridColumn)
    }

    onLoadMore(pageNumber: number, pageSize: number) {
        this.getArrearsAlerts({
            pathVariable: this.memberIdNum,
            requestorCallback: this,
            requestBody: {
                pageNumber: pageNumber,
                pageSize: pageSize
            }
        })
    }

    onInnerLoad(result: any): void {
        var me = this
        setTimeout(function () {
            me.$emit('successInnerResults', {
                results: Array<any>(result),
                resultCount: 1,
                hasMore: false
            })
        }, 100)
    }
}
